import { Box, Paper, Typography, Grid } from "@mui/material";
import { CheckCircle, Error, Warning, DataObject } from "@mui/icons-material";
import { CsvImportStats } from "../model";

export interface ImportStatsProps {
  stats: CsvImportStats | undefined;
  showResults?: boolean;
}

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: number;
  color: string;
}

const StatCard = ({ icon, label, value, color }: StatCardProps) => (
  <Paper
    sx={{
      p: 2,
      display: "flex",
      alignItems: "center",
      gap: 2,
      borderLeft: 4,
      borderColor: color,
    }}
  >
    <Box sx={{ color }}>{icon}</Box>
    <Box>
      <Typography variant="h5" fontWeight={600}>
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  </Paper>
);

export const ImportStats = ({ stats, showResults }: ImportStatsProps) => {
  if (!stats) return null;

  return (
    <Grid container spacing={2}>
      <Grid item xs={6} md={3}>
        <StatCard
          icon={<DataObject />}
          label="Total lignes"
          value={stats.totalRows || 0}
          color="primary.main"
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatCard
          icon={<CheckCircle />}
          label="Lignes valides"
          value={stats.validRows || 0}
          color="success.main"
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatCard
          icon={<Error />}
          label="Erreurs"
          value={stats.errorRows || 0}
          color="error.main"
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatCard
          icon={<Warning />}
          label="Doublons"
          value={stats.duplicateRows || 0}
          color="warning.main"
        />
      </Grid>

      {showResults && (
        <>
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
              Résultats de l'import
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <StatCard
              icon={<CheckCircle />}
              label="Créés"
              value={stats.created || 0}
              color="success.main"
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <StatCard
              icon={<CheckCircle />}
              label="Mis à jour"
              value={stats.updated || 0}
              color="info.main"
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <StatCard
              icon={<Warning />}
              label="Ignorés"
              value={stats.skipped || 0}
              color="grey.500"
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <StatCard
              icon={<Error />}
              label="Échecs"
              value={stats.failed || 0}
              color="error.main"
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
